import React from 'react';
import { CloudIcon, FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-slate-50 pt-20 pb-10 border-t border-slate-200" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-114">
          <div className="lg:col-span-2" data-id="element-115">
            <div className="flex items-center gap-2 mb-6" data-id="element-116">
              <div className="bg-blue-600 p-1.5 rounded-lg" data-id="element-117">
                <CloudIcon className="w-6 h-6 text-white" data-id="element-118" />
              </div>
              <span className="text-xl font-bold text-slate-900 tracking-tight" data-id="element-119">
                BizCloud<span className="text-blue-600" data-id="element-120">Desk</span>
              </span>
            </div>
            <p className="text-slate-600 max-w-md leading-relaxed mb-8" data-id="element-121">
              Professional cloud, CRM, VoIP, website, automation, and digital
              business solutions for small businesses and independent
              professionals.
            </p>
            <div className="flex gap-4" data-id="element-122">
              <a href="#" className="w-10 h-10 bg-white rounded-full border border-slate-200 flex items-center justify-center text-slate-400 hover:text-blue-600 hover:border-blue-600 transition-all" data-id="element-123">
                <FacebookIcon className="w-5 h-5" data-id="element-124" />
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full border border-slate-200 flex items-center justify-center text-slate-400 hover:text-blue-600 hover:border-blue-600 transition-all" data-id="element-125">
                <InstagramIcon className="w-5 h-5" data-id="element-126" />
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full border border-slate-200 flex items-center justify-center text-slate-400 hover:text-blue-600 hover:border-blue-600 transition-all" data-id="element-127">
                <LinkedinIcon className="w-5 h-5" data-id="element-128" />
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full border border-slate-200 flex items-center justify-center text-slate-400 hover:text-blue-600 hover:border-blue-600 transition-all" data-id="element-129">
                <TwitterIcon className="w-5 h-5" data-id="element-130" />
              </a>
            </div>
          </div>

          <div data-id="element-131">
            <h4 className="font-bold text-slate-900 mb-6" data-id="element-132">Quick Links</h4>
            <ul className="space-y-4" data-id="element-133">
              <li data-id="element-134">
                <button onClick={() => scrollToSection('early-access')} className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-135">
                  Early Access
                </button>
              </li>
              <li data-id="element-136">
                <button onClick={() => scrollToSection('services')} className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-137">
                  Services Preview
                </button>
              </li>
              <li data-id="element-138">
                <button onClick={() => scrollToSection('contact')} className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-139">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-140">
            <h4 className="font-bold text-slate-900 mb-6" data-id="element-141">Legal</h4>
            <ul className="space-y-4" data-id="element-142">
              <li data-id="element-143">
                <span className="text-slate-400 cursor-not-allowed" data-id="element-144">
                  Privacy Policy
                </span>
              </li>
              <li data-id="element-145">
                <span className="text-slate-400 cursor-not-allowed" data-id="element-146">
                  Terms of Use
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-slate-500" data-id="element-147">
          <div className="text-center md:text-left" data-id="element-148">
            <p data-id="element-149">© 2026 BizCloudDesk. All rights reserved.</p>
          </div>

          <div className="flex items-center gap-4" data-id="element-150">
            <span className="font-medium text-slate-400" data-id="element-151">Follow us:</span>
            <div className="flex gap-4" data-id="element-152">
              <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-153">
                Facebook
              </a>
              <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-154">
                Instagram
              </a>
              <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-155">
                LinkedIn
              </a>
              <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-156">
                X
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}